<div
  class="booking-header flex justify-between bg-white px-2 pb-2 shadow-sm lg:hidden flex-wrap"
>
  <div class="w-10">
    <app-ui-icon-button
      (click)="previousStep()"
      *ngIf="!isFirstStep"
      icon="chevron_back"
    ></app-ui-icon-button>
  </div>
  <div>
    <app-stepper-header></app-stepper-header>
  </div>
  <div class="flex justify-end">
    <app-ui-icon-button (click)="closeBooking()" icon="close"></app-ui-icon-button>
  </div>

  <div class="w-full flex justify-center pt-2">
    <app-stepper-icons></app-stepper-icons>
  </div>

</div>
